import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import StepRoutes from "../../../Routes/steps_routes";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import Pagination from "../../../Components/layouts/pagination";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import DynamicFilterInput from "../../../Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../../Components/layouts/filter.select";
import LoadingPage from "../../../Components/layouts/loading";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentPage,
  setReduxFilters,
} from "../../../redux/Filtered leads/followupLeadReducer";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcCallTransfer, FcPieChart } from "react-icons/fc";
// import CallTrackingTable from "./Call Tracking/calltracking.table";
import SimpleButton from "../../../Components/layouts/simple_button";
import SalesPerformanceTable from "./salesPerformanceTable";
// import CallTrackingChart from "./Call Tracking/calltracking.graph";

function formatSecondsToHMS(seconds) {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  const pad = (n) => n.toString().padStart(2, "0");
  return `${pad(hrs)}:${pad(mins)}:${pad(secs)}`;
}

const CallTracking = () => {
  const user = useSelector((store) => store?.login?.user);
  const store = useSelector((store) => store.followupLeadsFilters);

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [leadOwner, setLeadOwner] = useState([]);

  const [filters, setFilters] = useState(store.filters);

  const [page, setCurrPage] = useState(store.currentPage);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [data, setData] = useState([]);
  const [chartData, setChartData] = useState(null);

  /* ---------------- GET TABLE DATA ---------------- */

  useEffect(() => {
    setLoading(true);

    performRequest(
      "GET",
      getFilteredURL(`/salesPerformance`, store.currentPage, store.filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.salesPerformanceDataCount / 50));
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => CustomErrorResponse(err))
      .finally(() => setLoading(false));
  }, [refresh, store.currentPage, store.filters]);

  /* ---------------- GET LEAD OWNERS ---------------- */

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => {
        if (res.data) {
          setLeadOwner(
            res.data.filter(
              (el) =>
                el?.role === process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                el?.role === process.env.REACT_APP_ROLE_SALLE ||
                el?.role === process.env.REACT_APP_ROLE_SALES_MANAGER
            )
          );
        }
      })
      .catch((err) => CustomErrorResponse(err));
  }, []);

  /* ---------------- PAGINATION ---------------- */

  useEffect(() => {
    setCurrPage(store.currentPage);
    setShowPage(Math.floor((store.currentPage - 1) / 5) * 5 + 1);
  }, [store.currentPage]);

  const setPage = (p) => {
    dispatch(setCurrentPage(p));
  };

  /* ---------------- APPLY FILTER ---------------- */

  const applyFilter = () => {
    dispatch(setCurrentPage(1));
    dispatch(setReduxFilters(filters));

    setRefresh(!refresh);

    const url = `/callTracking/getCallDataForChart?startdate=${filters.startdate}&enddate=${filters.enddate}&salesPersonName=${filters.leadowner}`;

    performRequest("GET", url)
      .then((res) => {
        if (res.status === 200) {
          setChartData(res.data);
        }
      })
      .catch((err) => CustomErrorResponse(err));
  };

  /* ---------------- RESET FILTER ---------------- */

  const resetFilter = () => {
    const emptyFilters = {
      startdate: "",
      enddate: "",
      leadname: "",
      leadowner: "",
      callType: "",
    };

    setFilters(emptyFilters);
    dispatch(setReduxFilters(emptyFilters));
    dispatch(setCurrentPage(1));

    setRefresh(!refresh);
  };

  /* ---------------- GET RECORDS BUTTON ---------------- */

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          {/* HEADER */}
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row align-items-center">
                <div className="col-6">
                  <h2 className="page-title">
                    <FcPieChart className="fs-2 me-1" />
                    Performance analytics
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>

                <div className="col-6 text-end"></div>
              </div>
            </div>
          </div>

          {/* BODY */}

          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                {/* FILTER SECTION */}

                <div className="col-md-3">
                  <div className="card p-3">
                    <h3>Filter result</h3>

                    <DynamicFilterInput
                      label="Start Date"
                      type="date"
                      value={filters.startdate}
                      onChange={(e) =>
                        setFilters({ ...filters, startdate: e.target.value })
                      }
                    />

                    <DynamicFilterInput
                      label="End Date"
                      type="date"
                      value={filters.enddate}
                      onChange={(e) =>
                        setFilters({ ...filters, enddate: e.target.value })
                      }
                    />

                    <DynamicFilterSelect
                      label="Lead Owner"
                      value={filters.leadowner}
                      onChange={(e) =>
                        setFilters({ ...filters, leadowner: e.target.value })
                      }
                    >
                      <option value="">Select All</option>

                      {leadOwner?.map((lead, index) => (
                        <option key={index} value={lead?.email}>
                          {lead?.userName}
                        </option>
                      ))}
                    </DynamicFilterSelect>

                    <div className="row mt-3">
                      <div className="col-6">
                        <button
                          onClick={applyFilter}
                          className="btn btn-success w-100"
                        >
                          Apply
                        </button>
                      </div>

                      <div className="col-6">
                        <button
                          onClick={resetFilter}
                          className="btn btn-secondary w-100"
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* CHART + TABLE */}

                <div className="col-md-9">
                  <div className="card p-3">
                    {data?.salesPerformanceData && (
                      <SalesPerformanceTable
                        data={data?.salesPerformanceData}
                      />
                    )}
                  </div>

                  <div className="card mt-3">
                    {/* {data && <CallTrackingTable callsData={data?.CallRecord} />} */}

                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.salesPerformanceData?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default CallTracking;
